/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateExerciseSchema } from '../models/CreateExerciseSchema';
import type { GetExerciseSchema } from '../models/GetExerciseSchema';
import type { GetGroupExerciseCategorySchema } from '../models/GetGroupExerciseCategorySchema';
import type { UpdateExerciseSchema } from '../models/UpdateExerciseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExercisesApi {
    /**
     * Api Delete
     * Delete exercise.<br>Required permission: edit_exercises
     * @returns void
     * @throws ApiError
     */
    public static exercisesApiDeleteDelete({
        exerciseId,
    }: {
        exerciseId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/exercises/{exercise_id}/',
            path: {
                'exercise_id': exerciseId,
            },
        });
    }
    /**
     * Api Get Detail
     * Get detail of exercise.<br>Required permission: get_exercises
     * @returns GetExerciseSchema OK
     * @throws ApiError
     */
    public static exercisesApiGetDetailGet({
        exerciseId,
    }: {
        exerciseId: string,
    }): CancelablePromise<GetExerciseSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/exercises/{exercise_id}/',
            path: {
                'exercise_id': exerciseId,
            },
        });
    }
    /**
     * Api Patch
     * Patch exercise.<br>Required permission: edit_exercises
     * @returns GetExerciseSchema Created
     * @throws ApiError
     */
    public static exercisesApiPatchPost({
        exerciseId,
        formData,
    }: {
        exerciseId: string,
        formData: {
            images?: (Array<Blob> | null);
            videos?: (Array<Blob> | null);
            data: UpdateExerciseSchema;
        },
    }): CancelablePromise<GetExerciseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/exercises/{exercise_id}/',
            path: {
                'exercise_id': exerciseId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Api Get
     * Get exercises.<br>Required permission: get_exercises
     * @returns GetGroupExerciseCategorySchema OK
     * @throws ApiError
     */
    public static exercisesApiGetGet({
        patientId,
    }: {
        patientId?: (string | null),
    }): CancelablePromise<Array<GetGroupExerciseCategorySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/exercises/',
            query: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Api Post
     * Create exercise.<br>Required permission: edit_exercises
     * @returns GetExerciseSchema Created
     * @throws ApiError
     */
    public static exercisesApiPostPost({
        formData,
    }: {
        formData: {
            images?: (Array<Blob> | null);
            videos?: (Array<Blob> | null);
            data: CreateExerciseSchema;
        },
    }): CancelablePromise<GetExerciseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/exercises/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
